import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getTags = (params) => {
    return axios.get(`${backendHost}/api/admin/users/tags`, {params});
};